import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-up2",
  "use": "icon-up2-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-up2\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.49991 5.4307L3.79286 9.66732L3.04028 9.00882L7.12362 4.34215L7.49991 3.91211L7.87619 4.34215L11.9595 9.00882L11.207 9.66732L7.49991 5.4307Z\" fill=\"#999999\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol